import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useSiteContent } from '../context/SiteContentContext';

const ElementsSection = () => {
  const [expandedElement, setExpandedElement] = useState(null);
  const { elements, getContent } = useSiteContent();

  const toggleElement = (id) => {
    setExpandedElement(expandedElement === id ? null : id);
  };

  // Use elements from API, with image override from site content if available
  const displayElements = elements.map(element => ({
    ...element,
    image: getContent(`element_${element.id}`, element.image)
  }));

  if (displayElements.length === 0) {
    return null;
  }

  return (
    <section id="elements" className="section-padding bg-card-bg">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="heading-2 mb-6">Choose Your Element</h2>
          <p className="body-medium text-text-secondary max-w-2xl mx-auto">
            Four elemental paths. Four unique playstyles. Which will you master?
          </p>
        </div>

        <div className="elements-grid">
          {displayElements.map((element) => (
            <div 
              key={element.id} 
              className="element-card"
              style={{ '--element-color': element.color }}
            >
              <div className="element-image-wrapper">
                <img
                  src={element.image}
                  alt={element.name}
                  className="element-image"
                />
                <div className="element-overlay"></div>
                <div className="element-badge">
                  {element.name}
                </div>
              </div>
              
              <div className="element-content">
                <h3 className="heading-4 mb-2">{element.title}</h3>
                <p className="body-small mb-4">{element.description}</p>
                
                <button 
                  onClick={() => toggleElement(element.id)}
                  className="abilities-toggle"
                >
                  <span className="caption">Abilities</span>
                  {expandedElement === element.id ? (
                    <ChevronUp size={18} />
                  ) : (
                    <ChevronDown size={18} />
                  )}
                </button>

                {expandedElement === element.id && (
                  <div className="abilities-list">
                    {element.abilities.map((ability, abilityIndex) => {
                      const abilityName = typeof ability === 'string' ? ability : ability.name;
                      const abilityIcon = typeof ability === 'object' ? ability.icon : null;
                      const abilityKey = `${element.id || element.name}-ability-${abilityIndex}-${abilityName}`;
                      
                      return (
                        <div key={abilityKey} className="ability-item">
                          {abilityIcon ? (
                            <img 
                              src={abilityIcon} 
                              alt={abilityName}
                              className="w-5 h-5 rounded object-cover flex-shrink-0"
                              onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.nextSibling.style.display = 'block';
                              }}
                            />
                          ) : null}
                          <div 
                            className="ability-dot"
                            style={{ display: abilityIcon ? 'none' : 'block' }}
                          ></div>
                          <span className="body-small">{abilityName}</span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ElementsSection;
